<template>
  <div class="container-404">
    <div><router-link to="/">Main page</router-link></div>
    <h3>Not found</h3>
  </div>
</template>

<script>

export default {
  name: 'Status404',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container-404 {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
